<ng-container *ngIf="canInputConsumptions()">
  <div class="pb-5">
    <!-- Título da secção de consumos -->
    <div class="d-flex align-items-center justify-content-center gap-2 mb-2 text-muted small">
      <i class="far fa-calendar-days"></i>
      <span>
        {{ 'PREENCHA OS CONSUMOS MENSAIS DOS ÚLTIMOS 12 MESES' | translate }}
      </span>
    </div>


    <!-- Indicador de preenchimento dos meses -->
    <div class="d-flex justify-content-center gap-2 flex-wrap ">
      <ng-container *ngFor="let form of consumptionsFormArray.controls; let i = index">
        <div class="month-dot" [ngClass]="getMonthDotClass(form)" [@dotState]="getMonthDotClass(form)"
          [title]="getMonthTooltip(form)" (click)="scrollToMonth(i)">
          <span class="dot-label">{{ (i + 1) < 10 ? '0' + (i + 1) : i + 1 }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Tabela de consumos -->
  <div class="main-container d-flex flex-column consumption-table mb-5" style="max-height: 350px; overflow: hidden;">
    <!-- Sticky Header -->
    <div class="sticky-top bg-light border-bottom pt-3 pb-2 z-2 px-2">
      <div class="row small text-uppercase fw-semibold px-2">
        <div class="col-2">{{ 'MONTH' | translate }}</div>
        <div class="col text-center" *ngFor="let input of possibleConsumptionInputKeys">
          {{ input | translate }}
        </div>
        <div class="col-auto text-end">{{ 'TOTAL' | translate }}</div>
      </div>
    </div>

    <!-- Sticky Price Input Row -->
    <form [formGroup]="parentFormGroup" *ngIf="parentFormGroup && allowsPriceInput">
      <div class="sticky-top bg-white border-bottom py-2 z-3 px-2">
        <div class="d-grid align-items-center px-2" [ngStyle]="getGridTemplateStyle(true)">
          <div class="fw-bold text-uppercase small text-gray-600">
            <!--<i class="fas fa-euro-sign fa-fw"></i>-->
            {{ 'UNIT_PRICE' | translate }}
          </div>
          <div *ngFor="let input of possiblePriceInputValues">
            <div class="form-inline-input d-flex align-items-center border rounded px-2 bg-white">
              <input type="number" class="form-control border-0 p-1" [formControlName]="input" />
              <span class="text-muted ms-1 small">€</span>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Scrollable Consumption Rows -->
    <div class="flex-grow-1 overflow-auto px-2">
      <ng-container *ngIf="singleMonthConsumptionInput; then singleMonth; else multiMonth"></ng-container>

      <!-- Single Month Form -->
      <ng-template #singleMonth>
        <form [formGroup]="singleMonthInputFormGroup" *ngIf="singleMonthInputFormGroup">
          <div class="d-grid align-items-center py-2 mb-2 border-bottom px-2 consumption-row pe-2"
            [ngStyle]="getGridTemplateStyle(false)">
            <div>
              <is-date-time-picker formControlName="date" [dateFormat]="'MMMM YYYY'" [Type]="datepickerType"
                [clearDatesBtn]="false"></is-date-time-picker>
            </div>

            <div *ngFor="let input of possibleConsumptionInputValues"
              [ngClass]="{'is-invalid': singleMonthInputFormGroup.get(input)?.invalid && singleMonthInputFormGroup.get(input)?.touched}">
              <div class="form-inline-input d-flex align-items-center border rounded">
                <input type="number" energyKwhInput class="form-control border-0 p-1" [formControlName]="input" />
                <span class="text-muted ms-1 small">{{ 'consumption' | energyUnit }}</span>
              </div>
            </div>
          </div>
        </form>
      </ng-template>

      <!-- Multi-Month Form -->
      <ng-template #multiMonth>
        <ng-container *ngFor="let consumptionsForm of consumptionsFormArray.controls; let i = index;">
          <form [formGroup]="consumptionsForm">
            <div #monthRow class="d-grid align-items-center py-2 mb-2 border-bottom px-2 consumption-row-container"
              [attr.data-month-index]="i" [id]="'month-row-' + i" [ngStyle]="getGridTemplateStyle(false)">
              <div class="fw-medium small text-muted">
                <i class="far fa-meter-bolt text-warning" *ngIf="isElectricity"></i>
                <i class="far fa-meter-fire text-danger" *ngIf="!isElectricity"></i>

                {{ consumptionsForm.controls.date.value | date: 'MMMM yyyy': undefined: 'pt-PT' }}
              </div>

              <div *ngFor="let input of possibleConsumptionInputValues; let i1 = index">
                <div class="form-inline-input d-flex border align-items-center rounded pe-2"
                  [ngClass]="{'is-invalid': consumptionsForm.get(input)?.invalid && consumptionsForm.get(input)?.touched}">
                  <input type="number" energyKwhInput class="form-control-2 border-0 p-1" [formControlName]="input"
                    (paste)="copyPasteHandler(i, i1, $event)" />
                  <span class="text-muted ms-1 small">{{ 'consumption' | energyUnit }}</span>
                </div>
              </div>

              <!-- Row total -->
              <div class="text-end small text-muted">
                {{ getMonthlyTotal(i) | kwhEnergy }} {{ 'consumption' | energyUnit }}
              </div>

            </div>
          </form>
        </ng-container>
      </ng-template>
    </div>

    <!-- Sticky Total Row -->
    <div class="sticky-bottom bg-light pt-3 pb-2 z-3 px-2">
      <div class="row align-items-center px-2">
        <div class="col-2 fw-bold text-uppercase small">{{ 'TOTAL_CONSUMPTION' | translate }}</div>
        <div class="col">
          <div class="form-inline-input d-flex align-items-center border rounded pe-2 bg-white">
            <input type="text" class="form-control border-0 p-1" disabled [value]="sumTotal | kwhEnergy" />
            <span class="text-muted ms-1 small">{{ 'consumption' | energyUnit }}</span>
          </div>
        </div>
        <!--<div class="col" *ngIf="allowsPriceInput">
          <div class="form-inline-input d-flex align-items-center border rounded px-2 bg-white">
            <input type="number" class="form-control border-0 p-1" disabled [value]="priceSumTotal" />
            <span class="text-muted ms-1 small">€</span>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</ng-container>